import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Components/Sidebar";
import "./App.css";
import ScreenMessage from "./Components/ScreenMessage/ScreenMessage";
import useScreenWidth from "./utils/useScreenWidth";


function App() {
  const location = useLocation();
  const screenWidth = useScreenWidth();

  if (screenWidth < 1024) {
    return <ScreenMessage />;
  }

  return (
    <div className="app">
      <div className="layout">
        <Sidebar />
        <div className="layout__content">
          <div className={location.pathname !== "/chat" ? "layout__page" : ""}>
              <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
